export const homeRoutePath = '/inicio';
export const loginRoutePath = '/login';
export const bannersRoutePath = '/banners';
export const shortcutsRoutePath = '/shortcuts';
export const customersRoutePath = '/clientes';
export const distributorsRoutePath = '/distribuidoras';
export const ordersRoutePath = '/pedidos';
export const productsRoutePath = '/productos';
export const navigationTreeRoutePath = '/arboles';
export const suggestedProductRoutePath = '/producto-sugerido';
export const maintenanceRoutePath = '/mantenimiento';
export const promotionsRoutePath = '/promociones';
export const usersRoutePath = '/usuarios';
export const staticPagesRoutePath = '/links-importantes';
export const yapeRoutePath = '/yape';
export const downloadsUploadsRoutePath = '/descargas-cargas';

export const masiveExportsRoutePath = '/exportaciones-masivas';
export const notFoundRoutePath = '/not-found';
